(function(){
 'use strict';
 function init(){
  var body=document.querySelector('.fmt-story-body'),toc=document.querySelector('.fmt-story-toc');
  if(body&&toc&&!toc.dataset.ready){
   toc.dataset.ready='true';var list=toc.querySelector('ol');
   body.querySelectorAll('h2').forEach(function(heading,i){
    if(!heading.id){var id='story-section-'+(i+1);while(document.getElementById(id))id+='-a';heading.id=id;}
    var item=document.createElement('li'),link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;item.appendChild(link);list.appendChild(item);
   });toc.hidden=list.children.length<2;
  }
  if(false){
   var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){observer.unobserve(entry.target);entry.target.animate([{transform:'translateY(14px)',opacity:.6},{transform:'translateY(0)',opacity:1}],{duration:430,easing:'cubic-bezier(.2,.7,.2,1)'});}});},{threshold:.12});
   document.querySelectorAll('[data-fmt-reveal],.fmt-workbench article,.fmt-loc,.archive-care__item').forEach(function(el){if(!el.dataset.revealReady){el.dataset.revealReady='true';observer.observe(el);}});
  }
 }
 var dialog,previous;
 document.addEventListener('click',function(event){
  var trigger=event.target.closest('[data-fmt-photo]');if(!trigger)return;
  if(!dialog){
   dialog=document.createElement('dialog');dialog.className='fmt-place-dialog';dialog.setAttribute('aria-labelledby','fmt-place-title');
   dialog.innerHTML='<header><h2 id="fmt-place-title"></h2><button type="button" autofocus><span>Close</span> <span aria-hidden="true">×</span></button></header><img alt=""><footer><p></p><a target="_blank" rel="noopener">View in Google ↗</a></footer>';
   document.body.appendChild(dialog);dialog.querySelector('button').addEventListener('click',function(){dialog.close();});
   dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
   dialog.addEventListener('close',function(){if(previous&&previous.isConnected)previous.focus();});
  }
  previous=trigger;dialog.querySelector('h2').textContent=trigger.dataset.fmtPhotoTitle;
  var photo=dialog.querySelector('img');photo.src=trigger.dataset.fmtPhoto;photo.alt=trigger.dataset.fmtPhotoCaption;
  dialog.querySelector('p').textContent=trigger.dataset.fmtPhotoCaption+' Photo from the Family Media Transfer Google listing.';
  dialog.querySelector('a').href=trigger.dataset.fmtPhotoMap;dialog.showModal();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
